import React from "react";
import clsx from "clsx";

/**
 * SectionRenderer component - displays information sections with title and grid layout
 * @param {string} identifier - Unique identifier for the section
 * @param {string} title - Section title
 * @param {object} data - Data object containing the values to display
 * @param {array} allowedKeys - Keys from data object to display
 * @param {object} displayValues - Custom display names for keys
 * @param {object} customValues - Custom rendered values for keys
 */
const SectionRenderer = ({
  identifier,
  title,
  data,
  allowedKeys,
  displayValues,
  customValues,
}) => {
  return (
    <div className="section mt-10 pb-5 px-5 border-b-2 border-gray-200">
      <div className="title flex gap-2 items-center cursor-pointer font-bold text-lg">
        {title}
      </div>
      <div className="content px-5 grid grid-rows-[0fr] transition-all ease-in-out duration-500">
        <div className={clsx("grid", data && "grid-cols-4 gap-6")}>
          {!!data &&
            Object.keys(data).map(
              (key, index) =>
                allowedKeys.includes(key) && (
                  <div
                    key={index}
                    className="info flex flex-col gap-3 justify-start items-start"
                  >
                    <div className="key font-semibold">
                      {displayValues[key] || key}
                    </div>
                    <div className="value">
                      {!!customValues[key] ? customValues[key] : data[key]}
                    </div>
                  </div>
                )
            )}
        </div>
      </div>
    </div>
  );
};

export default SectionRenderer;
